import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { paths } from 'ogp/paths';
import { useCompanyRelativePath } from 'ogp/hooks';
import { useSubmitCreateWorkflowParams } from './use-submit-create-workflow.types';
import { WorkflowCreateForm } from '../../workflow-create-toolbox';
import { useCreateWorkflow } from '../use-create-workflow/use-create-workflow';

export const useSubmitCreateWorkflow = ({ mapNodesToDto }: useSubmitCreateWorkflowParams) => {
  const mutation = useCreateWorkflow();
  const navigate = useNavigate();
  const generatePath = useCompanyRelativePath();

  const onSubmit = useCallback(
    (data: WorkflowCreateForm) => {
      const graphData = mapNodesToDto();

      mutation.mutate(
        {
          ...data,
          graphData,
        },
        {
          onSuccess: () => {
            navigate(generatePath(paths.Workflows));
          },
        }
      );
    },
    [mapNodesToDto, mutation, navigate, generatePath]
  );

  return { onSubmit, mutation };
};
